import { Box, Tab, Tabs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { useI18n } from '../../../../application/language/useI18n';
import ApplicationTheme from '../../../../application/theme/ApplicationTheme';
import { IMainLayoutDomainStore } from '../../../layout/main/store/domain/IMainLayoutDomainStore';
import { UserInfoCard } from '../../../admin/page/passingListPage/parts/UserInfoCard';
import { PassingListPage } from '../../../admin/page/passingListPage/PassingListPage';
import { IPassingListPageDomain } from '../../../admin/page/passingListPage/store/IPassingListPageDomain';
import { PassingListPageDomain } from '../../../admin/page/passingListPage/store/PassingListPageDomain';
import { UserRating } from '../../../admin/page/usersRating/UserRating';
import { Colors } from '../../../design/color/Colors';
import { useDeferredCallback } from '../../../shared/hooks/useDeferredCallback';

const useStyles = makeStyles(() => ({
  indicator: {
    backgroundColor: Colors.primary,
  },
}));

export const LearningUserPage = observer(({ layoutDomain }: { layoutDomain: IMainLayoutDomainStore }) => {
  const [domain] = useState<IPassingListPageDomain>(new PassingListPageDomain(layoutDomain));
  const [tabIndex, setTabIndex] = useState(0);
  const i18n = useI18n();
  const classes = useStyles();

  useDeferredCallback(() => {
    const currentUser = layoutDomain.ui.activeUser.entity;
    domain.loadData(currentUser.id);
  }, [domain, layoutDomain.ui.activeUser.entity]);

  return (
    <ApplicationTheme>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h4" sx={{ paddingLeft: '16px' }}>
            {i18n.translate('learningUserPage.learningTitle')}
          </Typography>

          <UserInfoCard
            fio={layoutDomain.ui.activeUser.entity.displayName}
            role={layoutDomain.ui.activeUser.entity.systemRoleName}
            userData={domain.ui.userData.value}
          />
        </Box>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} classes={{ indicator: classes.indicator }}>
              <Tab sx={{ textTransform: 'capitalize' }} label={i18n.translate('learningUserPage.skillsMap')} />
              <Tab sx={{ textTransform: 'capitalize' }} label={i18n.translate('learningUserPage.usersRating')} />
            </Tabs>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: tabIndex === 0 ? 'flex' : 'none',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <PassingListPage layoutDomain={layoutDomain} passingListPageDomain={domain} />
          </Box>

          <Box
            sx={{
              flex: 1,
              display: tabIndex === 1 ? 'flex' : 'none',
              flexDirection: 'column',
              overflow: 'auto',
            }}
          >
            <UserRating layoutDomain={layoutDomain} />
          </Box>
        </Box>
      </Box>
    </ApplicationTheme>
  );
});
